module.exports = __webpack_public_path__ + "static/media/copy.b65d8990.svg";